// Framework and third-party non-ui
import React from 'react';

// App components

// JSON & Styles
import { makeStyles } from '@material-ui/core/styles';


const Attribute = ({attribute, optionClasses, onClick, accessibilityButtonAttrs, icon, iconClasses, value}) => {
    const useStyles = makeStyles({
        iconFlex: {
            display: 'flex',
            gap: '6px'
        },
        root: {
            maxWidth: 420,
            borderRadius: '10px',
            borderColor: '#4D7343',
            borderStyle: 'solid',
            borderWidth: '2px',
            color: '#4D7343',
            fontFamily: 'Open Sans',
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '24.5px',
            letterSpacing: '0.75px',
            textAlign: 'center',
            padding: '5px',
        },
        partial: {
            maxWidth: 420,
            borderRadius: '5px',
            borderColor: '#BF560A',
            borderStyle: 'solid',
            borderWidth: '2px',
            color: '#BF560A',
            fontFamily: 'Open Sans',
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '24.5px',
            letterSpacing: '0.75px',
            textAlign: 'center',
            padding: '5px',
        },
    });
    const classes = useStyles();

    return  (
            !value ?
                (<div style={{display: 'inline-block'}} className={optionClasses ? `${[...optionClasses, classes.root].join(' ')}` : `${classes.root}`} onClick={onClick} {...accessibilityButtonAttrs}>
                    {iconClasses && iconClasses.length ? 
                    (<div class={classes.iconFlex} >
                        <div className={`${[...iconClasses].join(' ')}`} />
                        <div>{attribute.toUpperCase()}</div>
                    </div>) :
                        <div>{attribute.toUpperCase()}</div>
                    }
                </div>)
            :
                (<div style={{display: 'inline-block'}} className={value === 'Partial' ? `${classes.root} ${classes.partial}` : `${classes.root}`}  onClick={onClick} {...accessibilityButtonAttrs}>
                    <div>{attribute.toUpperCase()} {value === 'Partial'? ('(PARTIAL)') : null}</div>
                </div>
                )
    )
};

export default Attribute;
